import { css } from "@emotion/react";

export const actionsContainer = css`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-right: 15px;
`;
